import React, { useState, useEffect } from 'react';
import { Container, Header, View, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Tabs, Tab, H2, H3, Grid, Col, H1 } from 'native-base';
import styles from './styles';

export default function DetailsTab({ details }) {
	return (
		<View style={{ backgroundColor: '#fff' }}>
			<View style={{ margin: '5%', backgroundColor: '#fff' }}>
				<View style={styles.detailsTabRow}>
					<Icon name="people" style={[styles.detailsTabIcon, { color: 'brown' }]} />
					<H3 style={styles.detailsTabLabel}>Business: </H3>
					<Text style={styles.detailsTabData}>{details.businessName}</Text>
				</View>
				<View style={styles.detailsTabRow}>
					<Icon name="contact" style={[styles.detailsTabIcon, { color: 'green' }]} />
					<H3 style={styles.detailsTabLabel}>Contact: </H3>
					<Text style={styles.detailsTabData}>{details.name}</Text>
				</View>
				{parseFloat(details.openingDebt) > 0 && (
					<View style={styles.detailsTabRow}>
						<Icon name="cash" style={[styles.detailsTabIcon, { color: 'blue' }]} />
						<H3 style={styles.detailsTabLabel}>Opening debt: </H3>
						<Text style={styles.detailsTabData}>£{details.openingDebt}</Text>
					</View>
				)}
				<View style={styles.detailsTabRow}>
					<Icon name="home" style={[styles.detailsTabIcon, { color: 'grey' }]} />
					<H3 style={styles.detailsTabLabel}>Address: </H3>
					<Text style={[styles.detailsTabData, { color: details.address ? 'black' : 'grey' }]}>
						{details.address
							? details.address1 +
							  (details.address1 && ', ') +
							  details.address2 +
							  (details.address2 && ', ') +
							  details.city +
							  (details.city && ', ') +
							  details.region +
							  (details.region && ', ') +
							  details.postCode.replace(/ /g, '\u00A0') //non-breaking space in between postcode
							: '(Not supplied)'}
					</Text>
				</View>
				<View style={styles.detailsTabRow}>
					<Icon name="md-call" style={[styles.detailsTabIcon, { color: 'green' }]} />
					<H3 style={styles.detailsTabLabel}>Telephone: </H3>
					<Text style={[styles.detailsTabData, { color: details.tel ? 'black' : 'grey' }]}>{details.tel ? details.tel : '(Not supplied)'}</Text>
				</View>
				{!!details.fax && (
					<View style={styles.detailsTabRow}>
						<Icon name="md-call" style={styles.detailsTabIcon} />
						<H3 style={styles.detailsTabLabel}>Fax: </H3>
						<Text style={styles.detailsTabData}>{details.fax}</Text>
					</View>
				)}

				<View style={styles.detailsTabRow}>
					<Icon name="at" style={[styles.detailsTabIcon, { color: 'purple' }]} />
					<H3 style={styles.detailsTabLabel}>Email: </H3>
					<Text style={[styles.detailsTabData, { color: details.email ? 'black' : 'grey' }]}>{details.email ? details.email : '(Not supplied)'}</Text>
				</View>
				<Text>{details.notes}</Text>
			</View>
		</View>
	);
}
